<template>
  <div class="login">
    <div class="login__overlay">
      <div class="login__content">
        <img src="../assets/img/login-logo.svg" alt="Logo" class="login__logo">
        <h2 class="login__title">Восстановление пароля</h2>
        <p class="login__text">Пожалуйста создайте новый пароль</p>
        <form @submit.prevent="setNewPassword">
          <div class="login__inputWrapper">
            <input
              class="login__input"
              type="password"
              v-model="password"
              required
              @focus="focused.password = true"
              @blur="focused.password = password !== ''"
              :class="{ error: passwordError }"
            />
            <label :class="{ floating: focused.password || password !== '' }">новый пароль</label>
          </div>
          <div class="login__inputWrapper">
            <input
              class="login__input"
              type="password"
              v-model="clonePassword"
              required
              @focus="focused.clonePassword = true"
              @blur="focused.clonePassword = clonePassword !== ''"
              :class="{ error: passwordError }"
            />
            <label :class="{ floating: focused.clonePassword || clonePassword !== '' }">повторить пароль</label>
          </div>
          <p v-if="passwordError" class="login__error">Пароли не совпадают</p>

          <button class="login__btn" :disabled="isLoading" :class="{ 'login__btn--loading': isLoading }" type="submit">
            {{ isLoading ? 'Уже создаём…' : 'Создать новый пароль' }}
          </button>
          <p v-if="error" class="login__error">{{ error }}</p>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'SetNewPassword',
  data() {
    return {
      password: '',
      clonePassword: '',
      error: null,
      isLoading: false,
      focused: {
        password: false,
        clonePassword: false,
      },
      passwordError: false, // Ошибка при несовпадении паролей
      code: null, // Код из URL
    };
  },
  mounted() {
    this.extractCodeFromUrl();
  },
  methods: {
    extractCodeFromUrl() {
      const code = this.$route.params.code || this.$route.query.code; // Получаем код из URL
      if (code) {
        this.code = code;
      } else {
        this.error = 'Ошибка: отсутствует код восстановления';
      }
    },
    async setNewPassword() {
      this.passwordError = this.password !== this.clonePassword;
      if (this.passwordError) return; // Если пароли не совпадают, форма не отправляется

      this.isLoading = true;
      this.error = null;

      try {
        const response = await axios.post('/api/pis/v1/user/confirm_recover_password', {
          code: this.code,
          newPassword: this.password,
        }, {
          headers: {
            'X-API-KEY': 'Ha12d-234f_1AUqw-KkoQG-QrtwQ1',
            'Content-Type': 'application/json',
          },
        });

        console.log('Пароль успешно изменён:', response.data);
        this.$router.push('/'); // Перенаправление на главную
      } catch (error) {
        this.error = error.response?.data?.message || 'Ошибка при изменении пароля';
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>


<style scoped>
.login__overlay {
  background-image: url("../assets/img/signup-bg.png");
  background-position: center;
  background-size: cover;
}
.login__title{
  font-size: 20px;
}
.error {
  border: 1px solid red;
}
</style>